<lx-form-field
  [disabled]="disabled"
  [isValid]="valid"
  [label]="label"
  [required]="required"
  [small]="small && !buttonView"
  [withoutHelper]="!buttonView"
  [ngClass]="{ 'lx-form-field--without-label': !label }"
  [iconValidation]="iconValidation"
>
  <ng-content select="[extra-header]"></ng-content>
  <p-dropdown
    *ngIf="!buttonView && !mobile"
    placeholder="{{ placeholder }}"
    filterPlaceholder="Search"
    emptyFilterMessage="{{ noDataText }}"
    i18n-placeholder
    i18n-filterPlaceholder
    i18n-emptyFilterMessage
    [filter]="searchEnabled"
    [options]="itemList | lxSortBy : sortCriteria"
    [filterBy]="'name'"
    [disabled]="disabled"
    [(ngModel)]="selectedValue"
    [optionLabel]="'name'"
    [optionValue]="$any(valueExpr)"
    (ngModelChange)="setSelectedItem($event)"
    (onShow)="onShowDropdown()"
    (onHide)="onHideDropdown()"
    (onBlur)="focusOut.emit()"
  >
    <ng-template pTemplate="selectedItem" *ngIf="selectedItemTemplate">
      <ng-container *ngTemplateOutlet="selectedItemTemplate; context: { $implicit: selectedItem }"></ng-container>
    </ng-template>
  </p-dropdown>
  <lx-button
    *ngIf="!buttonView && mobile"
    [icon]="'pi pi-chevron-down'"
    [text]="selectedValueText"
    [block]="true"
    [style]="{ width: '100%' }"
    [iconPos]="'after'"
    [disabled]="disabled"
    [btnRounded]="false"
    [buttonStyle]="'dropdown-square'"
    (buttonClick)="setDropdownPopup()"
  >
  </lx-button>
  <lx-dropdown-popup
    [visible]="isDropdownPopupOpen && mobile"
    [company]="company"
    [itemList]="itemList | lxSortBy : sortCriteria"
    [(ngModel)]="selectedValue"
    (ngModelChange)="setSelectedItem($event)"
    (dropdownPopupClosed)="isDropdownPopupOpen = false"
  >
  </lx-dropdown-popup>
  <div *ngIf="buttonView">
    <lx-button
      *ngIf="isOpen && !hideHelpMeChoose"
      class="form-field-selector__help-button"
      i18n-text
      text="Help me choose"
      [icon]="showDetails ? 'pi pi-times' : ''"
      [iconPos]="'after'"
      [btnRounded]="true"
      [buttonStyle]="'popover'"
      (click)="showDetails = !showDetails"
    >
    </lx-button>
    <lx-select-button-group
      [valueExpr]="valueExpr"
      displayExpr="name"
      [options]="itemList | lxSortBy : sortCriteria"
      [value]="value"
      [(isOpen)]="isOpen"
      [defaultSorting]="false"
      [customEvent$]="buttonGroupCustomEvent"
      (valueChange)="setSelectedItem($event)"
      (isOpenChange)="isOpenChanged($event)"
    >
      <ng-template #optionItem let-currentItem>
        <ng-container
          *ngTemplateOutlet="
            optionItemTemplate ? optionItemTemplate : defaultOptionItemTemplate;
            context: { $implicit: currentItem, showDetails: showDetails, isOpen: isOpen }
          "
        ></ng-container>
      </ng-template>
    </lx-select-button-group>
  </div>
</lx-form-field>

<ng-template #defaultOptionItemTemplate let-currentItem let-showDetails="showDetails">
  <lx-summary-card [mode]="showDetails ? 'back' : 'cover'" [item]="currentItem" titleExpression="name" imageExpression="thumbnailSmall"></lx-summary-card>
</ng-template>
